/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { WebhookDeliveryLogQueryV1 } from '../models/webhook-delivery-log-query-v-1';
import { WebhookRetryResultV1 } from '../models/webhook-retry-result-v-1';


/**
 * API for Webhook delivery logs
 */
@Injectable({
  providedIn: 'root',
})
export class WebhookDeliveryLogV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dispatchRetryApprovedRequestWebhookEvent
   */
  static readonly DispatchRetryApprovedRequestWebhookEventPath = '/v1/webhook-delivery/retry/approved/{requestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchRetryApprovedRequestWebhookEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchRetryApprovedRequestWebhookEvent$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WebhookRetryResultV1>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookDeliveryLogV1Service.DispatchRetryApprovedRequestWebhookEventPath, 'post');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WebhookRetryResultV1>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dispatchRetryApprovedRequestWebhookEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchRetryApprovedRequestWebhookEvent(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<WebhookRetryResultV1> {

    return this.dispatchRetryApprovedRequestWebhookEvent$Response(params,context).pipe(
      map((r: StrictHttpResponse<WebhookRetryResultV1>) => r.body as WebhookRetryResultV1)
    );
  }

  /**
   * Path part for operation listWebhookDeliveryLogQueryV1
   */
  static readonly ListWebhookDeliveryLogQueryV1Path = '/v1/webhook-delivery/log/{requestId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWebhookDeliveryLogQueryV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWebhookDeliveryLogQueryV1$Response(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<WebhookDeliveryLogQueryV1>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookDeliveryLogV1Service.ListWebhookDeliveryLogQueryV1Path, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WebhookDeliveryLogQueryV1>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWebhookDeliveryLogQueryV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWebhookDeliveryLogQueryV1(params: {
    requestId: string;
  },
  context?: HttpContext

): Observable<WebhookDeliveryLogQueryV1> {

    return this.listWebhookDeliveryLogQueryV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<WebhookDeliveryLogQueryV1>) => r.body as WebhookDeliveryLogQueryV1)
    );
  }

}
